import React from "react";

const HomeIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.875 10.0001L9.33667 2.53756C9.70333 2.17173 10.2967 2.17173 10.6625 2.53756L18.125 10.0001M3.75 8.12506V16.5626C3.75 17.0801 4.17 17.5001 4.6875 17.5001H8.125V13.4376C8.125 12.9201 8.545 12.5001 9.0625 12.5001H10.9375C11.455 12.5001 11.875 12.9201 11.875 13.4376V17.5001H15.3125C15.83 17.5001 16.25 17.0801 16.25 16.5626V8.12506M6.875 17.5001H13.75"
      stroke="#757373"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default HomeIconSvg;
